import { Space } from 'antd';
import { ReactNode } from 'react';
import { CheckCircleFilled, FileOutlined, WarningFilled } from '@ant-design/icons';
import { InvoiceFileTypes } from 'store/invoices/types';
import PreviewAction from './PreviewAction';

export const fileTypeMap: Record<InvoiceFileTypes, string> = {
    [InvoiceFileTypes.CUSTOMS_INVOICE]: 'Customs Invoice',
    [InvoiceFileTypes.SAD]: 'SAD',
    [InvoiceFileTypes.COMMERCIAL_INVOICE]: 'Commercial Invoice',
};

const warningStyle = { color: 'var(--warning-normal)' };

type Props = {
    fileName: string;
    documentType: InvoiceFileTypes;
    isHighlighted?: boolean;
    actions?: ReactNode;
    previewLoading?: boolean;
    onPreview?: () => void;
};

const Document = ({
    fileName,
    documentType,
    isHighlighted = false,
    onPreview,
    actions,
    previewLoading = false,
}: Props) => {
    const label = isHighlighted ? `${fileTypeMap[documentType]} Missing` : fileName;

    return (
        <li>
            <Space size={4}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {isHighlighted ? (
                        <WarningFilled style={{ ...warningStyle, fontSize: 16 }} />
                    ) : (
                        <CheckCircleFilled style={{ color: 'var(--success-normal)', fontSize: 16 }} />
                    )}
                </div>
                {!isHighlighted && (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <FileOutlined style={{ fontSize: 21 }} />
                    </div>
                )}
                <span style={isHighlighted ? warningStyle : undefined}>{label}</span>
            </Space>

            <span>{!isHighlighted && fileTypeMap[documentType]}</span>

            <Space size={6} style={{ justifySelf: 'flex-end' }}>
                {actions}
                {!isHighlighted && <PreviewAction onPreview={onPreview} previewLoading={previewLoading} />}
            </Space>
        </li>
    );
};

export default Document;
